// import React from "react";
// import CricketScore from "../Component/CricketScore";
// import Navbar from "../Component/Navbar";
// import PageTitle from "../Component/PageTitle";

// const Home = () => {
//   return (
//     <>
//       <Navbar />
//       <PageTitle
//         title="Live Cricket Score App - Real-Time Scores & Match Updates"
//         description="Stay updated with live cricket scores, match details, and real-time updates from cricket events around the world. Get the latest scores and in-depth match analysis on our app."
//         url=""
//       />
//       <CricketScore />
//     </>
//   );
// };

// export default Home;

import React from "react";
import CricketScore from "../Component/CricketScore";
import Navbar from "../Component/Navbar";
import PageTitle from "../Component/PageTitle";

const Home = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Live Cricket Score App - Real-Time Scores & Match Updates"
        description="Stay updated with live cricket scores, match details, and real-time updates from cricket events around the world. Get the latest scores and in-depth match analysis on our app."
        url=""
      />

     

      <CricketScore />
    </>
  );
};

export default Home;
